var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnnotationWithAi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon-bubble",
    d: "M7 8H11 M7 12H11 M5 4H9 M21 13.5V14C21 15.1046 20.1046 16 19 16H16L12 20L8 16H5C3.89543 16 3 15.1046 3 14V6C3 4.89543 3.89543 4 5 4",
    stroke: "var(--bubble-color, currentColor)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.5, 0.2) scale(0.50)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "icon-stars",
    d: "M19 10.5l1.5-4L24.5 5l-4-1.5L19 -0.5l-1.5 4L13.5 5l4 1.5L19 10.5zm-7.5-1L9 4 6.5 9.5 1 12l5.5 2.5L9 20l2.5-5.5L17 12l-5.5-2.5zM19 13.5l-1.5 4L13.5 19l4 1.5L19 24.5l1.5-4L24.5 19l-4-1.5L19 13.5z",
    fill: "var(--star-color, currentColor)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnotationWithAi);
export default __webpack_public_path__ + "static/media/AnnotationWithAI.2dde768e32a1c8c45fe15a6c2db17cdd.svg";
export { ForwardRef as ReactComponent };